// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"a706ee69","552":"c68343d9","580":"c68343d9","808":"c40de637"}[chunkId] + ".chunk.css";
};